import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

interface AuthState {
  isLoggedIn: boolean;
  me?: any;
}

const initialState: AuthState = {
  isLoggedIn: !!Cookies.get("is_logged_in"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<any>) => {
      state.isLoggedIn = true;
      Cookies.set("is_logged_in", "true");
      Cookies.set("access", action.payload.token.access);
      Cookies.set("refresh", action.payload.token.refresh);
      state.me = action.payload;
    },
    logout: (state) => {
      Cookies.remove("is_logged_in");
      Cookies.remove("access");
      Cookies.remove("refresh");
      state.isLoggedIn = false;

    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
